import * as tslib_1 from "tslib";
import { Component, Prop, Inject } from "vue-property-decorator";
import common from '@cloudpivot/common/pc';
import { BaseControl } from "../../controls";
import { FormRendererHelper } from "../form-renderer-helper";
import { PropertyNames } from "h3-forms";
let FormGroup = class FormGroup extends BaseControl {
    constructor() {
        super(...arguments);
        this.display = true;
    }
    get align() {
        return this.controlOpts.align;
    }
    get collapse() {
        const expand = this.controlOpts.expand;
        if (typeof expand === "boolean") {
            return !expand;
        }
        return false;
    }
    get tips() {
        if (this.isMobile) {
            return '';
        }
        let { tips } = this.control.options;
        return tips;
    }
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    setControl() {
        if (this.controlOpts.displayFormula) {
            const ctrl = this.findController(this.control.key);
            if (ctrl) {
                this.display = ctrl.display;
                this.subscribePropertyChange((change) => {
                    if (change.name === PropertyNames.Display) {
                        this.display = change.value;
                    }
                });
            }
        }
        else {
            this.display = !this.allChildrenHiddn();
        }
    }
    allChildrenHiddn() {
        const children = this.control.children;
        if (children && children.length > 0) {
            let formControls = [];
            FormRendererHelper.findFormControl(children, formControls);
            const result = formControls
                .every(c => {
                let ctrl = c.controller;
                if (!ctrl) {
                    ctrl = this.findController(c.key);
                }
                if (ctrl) {
                    return !ctrl.display;
                }
                return false;
            });
            return result;
        }
        return true;
    }
    mounted() {
        this.taskRef = setInterval(() => {
            this.display = !this.allChildrenHiddn();
        }, 500);
    }
    destroyed() {
        clearInterval(this.taskRef);
        super.destroyed();
    }
};
tslib_1.__decorate([
    Prop()
], FormGroup.prototype, "isMobile", void 0);
tslib_1.__decorate([
    Inject()
], FormGroup.prototype, "layoutTypeFn", void 0);
FormGroup = tslib_1.__decorate([
    Component({
        name: "form-group",
        components: {
            H3Panel: common.components.Panel,
        }
    })
], FormGroup);
export default FormGroup;
